var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.999 19.135H7.001c-1.135 0 -2.057 -0.922 -2.057 -2.057V11.047c0 -0.597 0.261 -1.166 0.713 -1.56l0.003 -0.003 4.821 -4.131c0.751 -0.641 1.855 -0.658 2.619 -0.045l5.184 4.145c0.49 0.387 0.771 0.974 0.771 1.605V17.074c0 1.138 -0.922 2.061 -2.057 2.061zm-10.217 -8.352c-0.079 0.069 -0.123 0.165 -0.123 0.264v6.031c0 0.189 0.154 0.343 0.343 0.343h9.998c0.189 0 0.343 -0.154 0.343 -0.343V11.061c0 -0.103 -0.048 -0.202 -0.127 -0.264l-5.184 -4.149c-0.127 -0.103 -0.312 -0.096 -0.439 0.01L6.782 10.783z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.11e11f226669c8dadf0b0a09d8912140.svg";
export { ForwardRef as ReactComponent };